import {
  Box,
  Button,
  Divider,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';

import { AppColors, config } from '../utils/utils';
import { NavLink, Link as RouterLink, useLocation } from 'react-router-dom';
import { navItems } from './Header';

const Footer: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // e.g. <600px

  const location = useLocation();

  return (
    <>
      <Box
        sx={{
          // background: `url('/static/images/img_tile_background.png')`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'end',
          color: AppColors.buttonTextColor,
          fontSize: isMobile ? '12px' : '16px',
          px: { xs: 1, sm: 5, md: 20, lg: 40 },
          pt: 2,
          gap: { xs: 1, sm: 5 },
        }}
      >
        {
          // !isMobile &&
          <Box
            sx={{
              position: 'relative',
              overflow: 'hidden',
              alignItems: 'flex-end',
              width: {
                xs: '100%',
                sm: '200px',
                md: '25%',
                lg: '25%',
                xl: 'auto',
              },
            }}
          >
            <Box
              component='img'
              src='/static/home_page/img_phone_with_qr.png'
              alt='Phone with QR'
              sx={{
                width: '100%',
                display: 'block',
                transform: 'translateY(20%)', // moves image up by 20% (cropping bottom)
                clipPath: 'inset(0 0 20% 0)', // hides 20% bottom
              }}
            />
          </Box>
        }

        <Box pb={2}>
          <Stack
            direction={isMobile ? 'column' : 'row'}
            spacing={isMobile ? 1 : 2}
            justifyContent='space-between'
            alignItems='center'
            color={AppColors.buttonTextColor}
            textAlign='center'
          >
            {/* Logo */}
            <Box
              component={RouterLink}
              to='/'
              sx={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
              }}
            >
              <Box
                component='img'
                src='/static/images/qr_buddy_text_logo.png'
                alt='QR Buddy Logo'
                sx={{ height: 40 }}
              />
            </Box>

            {/* <Stack direction={isMobile ? 'column' : 'row'} spacing={1}> */}
            <Stack direction={'row'} spacing={1}>
              <Button
                component='a'
                href={config.POP_PRESENTATION_LINK}
                target='_blank'
                rel='noopener noreferrer'
                sx={{
                  color: 'inherit',
                  textTransform: 'none',
                }}
              >
                Presentation
              </Button>
              {navItems
                .filter((item) => item.path !== location.pathname)
                .map((item) => (
                  <Button
                    key={item.label}
                    component={NavLink}
                    to={item.path}
                    sx={{
                      color: 'inherit',
                      textTransform: 'none',
                      '&.active': {
                        fontWeight: 'bold',
                      },
                    }}
                  >
                    {item.label}
                  </Button>
                ))}

              {/*<Button
              component={NavLink}
              to='mailto:support@knocard.com'
              //   href='mailto:support@knocard.com'
              target='_blank'
              //   underline='none'
              sx={{ color: 'white', textTransform: 'none' }}
            >
              Support@knocard.com
            </Button>*/}
            </Stack>
          </Stack>

          <Stack
            direction={isMobile ? 'column' : 'row'}
            spacing={isMobile ? 1 : 2}
            justifyContent='start'
            alignItems='center'
            textAlign='center'
            sx={{
              // px: 1,
              mt: 1,
            }}
          >
            <Stack direction={'row'} spacing={isMobile ? 1 : 2}>
              {/* <Typography fontSize={'inherit'}>
              {`Copyright ${new Date().getFullYear()} KnoCard ©`}
            </Typography>

            <Typography variant='body2'>|</Typography>

            <Typography fontSize={'inherit'}>All Rights Reserved</Typography> */}

              <Link
                href='mailto:support@knocard.com'
                target='_blank'
                underline='none'
                sx={{ color: AppColors.buttonTextColor }}
              >
                <Typography fontSize={'inherit'}>
                  Support@knocard.com
                </Typography>
              </Link>

              {!isMobile && <Typography variant='body2'>|</Typography>}
            </Stack>

            <Stack direction={'row'} spacing={isMobile ? 1 : 2}>
              {/* <Typography variant='body2'>|</Typography> */}

              <Link
                // href={`${process.env.PUBLIC_URL}/pdf/QR_Buddy_Terms_of_Use_Sept_2025.pdf`}
                href='/terms'
                target='_blank'
                underline='none'
                sx={{ color: AppColors.buttonTextColor }}
              >
                <Typography fontSize={'inherit'}>Terms of Use</Typography>
              </Link>

              <Typography variant='body2'>|</Typography>

              <Link
                // href={`${process.env.PUBLIC_URL}/pdf/QR_Buddy_Privacy_Policy_Sept_2025.pdf`}
                href='/privacy-policy'
                target='_blank'
                underline='none'
                sx={{ color: AppColors.buttonTextColor }}
              >
                <Typography fontSize={'inherit'}>Privacy Policy</Typography>
              </Link>
            </Stack>
          </Stack>

          <Divider sx={{ background: '#8c52ff', my: 1, width: 1, height: 2 }} />

          <Typography fontSize={'inherit'}>
            Patent Pending: This product is protected by a provisional patent
            application filed with the U.S. Patent and Trademark Office.
          </Typography>
          <Typography
            fontSize={'inherit'}
          >{`© ${new Date().getFullYear()} KnoCard LLC. All rights reserved.`}</Typography>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
